import styled from 'styled-components'

import BasePageLayout from 'layouts/PageLayout'
import { breakpoint } from 'utils'

interface MenuWrapperProps {
  headerHeight: number
}

export const MenuWrapper = styled.aside<MenuWrapperProps>`
  width: 100%;
  top: ${({ headerHeight }) => headerHeight + 32}px;

  /* Prevent the Menu from shrinking */
  flex-shrink: 0;

  margin: 0 0 16px 0;

  ${breakpoint('xs')`
    margin: 0 0 32px 0;
  `}

  ${breakpoint('md')`
    position: sticky;

    width: 260px;
    margin: 0 40px auto 0;
  `}
`

export const PageLayout = styled(BasePageLayout)`
  display: flex;

  margin-left: auto;
  margin-right: auto;
  justify-content: flex-start;

  width: 100%;
  max-width: 1200px;

  padding: 16px 16px 0;

  ${breakpoint('xs')`
    padding: 32px 32px 0;
  `}

  ${breakpoint('md')`
    flex-direction: row;
  `}
`

export const ContentWrapper = styled.div`
  max-width: 640px;
  flex: 1;
`
